import { render, staticRenderFns } from "./UserEditBuyType.vue?vue&type=template&id=f699777a&scoped=true&"
import script from "./UserEditBuyType.vue?vue&type=script&lang=js&"
export * from "./UserEditBuyType.vue?vue&type=script&lang=js&"
import style0 from "./UserEditBuyType.vue?vue&type=style&index=0&id=f699777a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f699777a",
  null
  
)

export default component.exports